var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompetitiveIcon = function SvgCompetitiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.795,
    height: 29.795,
    viewBox: "0 0 29.795 29.795",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M881.791,197.912v-2.483H860.273v2.483h-4.139v3.922c0,2.214.55,13.464,8,13.464l1.1-.006,1.054,1.384c1.526,1.54,2.8,2.505,3.912,3.582v3.311h-8.276v1.655h18.208v-1.655H871.86v-3.311c1.129-1.067,2.4-2.053,3.912-3.582l1.053-1.384a7,7,0,0,1,1.078.036c7.449,0,8.026-11.28,8.026-13.494v-3.922Zm-24,4v-2.342h2.483c.459,7.143,1.8,11.281,3.6,14.145h-.113c-6.1,0-5.97-9.815-5.97-11.8m26.484,0c0,1.988.124,11.8-5.97,11.8h-.114c1.8-2.865,3.141-7.009,3.6-14.145h2.483Z",
    transform: "translate(-856.134 -195.429)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompetitiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/competitive-icon.4ec4c512.svg";
export { ForwardRef as ReactComponent };